import { render, staticRenderFns } from "./FrontCard.vue?vue&type=template&id=ddd185de&scoped=true&"
import script from "./FrontCard.vue?vue&type=script&lang=js&"
export * from "./FrontCard.vue?vue&type=script&lang=js&"
import style0 from "./FrontCard.vue?vue&type=style&index=0&id=ddd185de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd185de",
  null
  
)

export default component.exports